import { FC } from "react";
import { Link, Stack } from "@mui/material";
import { BodyText, HeadingText1 } from "../styles/styledComponents";
import ScreenBase from "./ScreenBase";

const LicenseCancelScreen: FC = () => {
	return (
		<ScreenBase
			scrollableChildren={(
				<Stack component="section" spacing={4}>
					<HeadingText1>Checkout Canceled</HeadingText1>
					<BodyText>
						No worries &ndash; you weren't charged. Your song selection is still saved in your
						cart, so you can pick up right where you left off whenever you're ready.
					</BodyText>
					<Link href="/tunes">Return to your selection</Link>
				</Stack>
			)}
		/>
	);
};

export default LicenseCancelScreen;
